// Site Configuration and Mock Data for Personal Brand Website

export const siteConfig = {
  name: "Gaurav Shekhar",
  logo: "https://customer-assets.emergentagent.com/job_da6e2573-e205-475a-b3fb-87f32b7d7f0a/artifacts/6v9jyv1a_gaurav.png",
  profileImage: "https://customer-assets.emergentagent.com/job_da6e2573-e205-475a-b3fb-87f32b7d7f0a/artifacts/hmoq25y8_Gaurav2.png",
  tagline: "Empowering Leaders. Transforming Organizations.",
  socialLinks: {
    facebook: "https://www.facebook.com/gaurav.shekhar",
    twitter: "https://x.com/gauravshekhar",
    linkedin: "https://www.linkedin.com/in/gauravshekhar/",
    instagram: "https://www.instagram.com/gaurav_shekhar2003/",
  },
};

export const aboutData = {
  headline: "Building the Future Leaders, Today",
  subheadline: "Academic • Public Speaker • Community Leader",
  bio: `I'm a passionate leader dedicated to helping organizations and individuals unlock their full potential. With over 15 years of experience in leadership development, strategic consulting, and executive advisory, I've had the privilege of working with Fortune 500 companies, startups, and everything in between.

My journey began in the corporate world, where I quickly realized that true success comes not from individual achievements, but from empowering others to succeed. This revelation led me to dedicate my career to developing leaders at all levels.

Today, I combine practical business acumen with evidence-based leadership principles to deliver transformative results. Whether I'm on stage speaking to thousands, consulting with executive teams, or providing strategic advisory services, my mission remains the same: to create positive, lasting change.`,
  stats: [
    { label: "Years Experience", value: "15+" },
    { label: "My Mission", value: "Educate to Innovate" },
  ],
};

export const awardsData = [
  {
    id: 1,
    title: "Inducted in Dallas500",
    organization: "DCEO",
    year: "2024",
    description: "D CEO's signature special publication, the Dallas 500, features profiles of the most influential North Texas executives in more than 50 industry categories. ",
  },
  {
    id: 2,
    title: "40 under 40",
    organization: "Dallas Business Journal",
    year: "2023",
    description: "Each year, DBJ honors 40 rising stars in the local business world who have distinguished themselves in their companies, their communities and their industries. ",
  },
  {
    id: 3,
    title: "40 under 40",
    organization: "CDO Magazine",
    year: "2022",
    description: "A celebration of outstanding young professionals who are reshaping what modern data transformation looks like.",
  },
  {
    id: 4,
    title: "Visionary Educator of the Year",
    organization: "UiPath",
    year: "2022",
    description: "The UiPath Academic Alliance Visionary Educator program recognizes global educators who go above and beyond to prepare students for the future of work through Robotic Process Automation (RPA) and AI skills.",
  },
  {
    id: 5,
    title: "Graduate Faculty of the Year",
    organization: "Naveen Jindal School of Management, The University of Texas at Dallas",
    year: "2022",
    description: "The JSOM OWLIE Award stands for Outstanding, Worthy Leaders, Involved Exceptionally. This annual award event provides a unique platform to recognize students, faculty, staff, mentors and alumni.",
  },
  {
    id: 6,
    title: "Presidential Citation",
    organization: "Toastmasters International",
    year: "2021",
    description: "The Toastmasters International Presidential Citation is a prestigious annual award presented by the International President to members displaying exceptional dedication and service to the organization.",
  },
];

export const affiliationsData = [
  { name: "US India Chamber of Commerce DFW", role: "Executive Board Member" },
  { name: "Chinese Institute of Engineers DFW", role: "Board Member" },
  { name: "Beta Gamma Sigma DFW Alumni Chapter", role: "President" },
  { name: "Institute of Electrical and Electronics Engineers (IEE)", role: "Senior Member" },
  { name: "Lions Clubs International", role: "Melvin Jones Fellow" },
  { name: "Association of Information Systems", role: "Past President (SIG ITProjMgmt)" },
  { name: "Project Management Institute/INFORMS", role: "Member" },
  { name: "Toastmasters International", role: "Past District Director" },
];

export const videosData = [
  {
    id: 1,
    slug: "tech-legacies-college-readiness",
    title: "The Future of Leadership in AI Era",
    description: "Exploring how leaders must adapt to thrive in an AI-driven world.",
    fullDescription: "In this episode, we dive deep into the rapidly evolving landscape of leadership in an age dominated by artificial intelligence. Learn how successful leaders are adapting their strategies, developing new competencies, and leveraging AI to enhance their decision-making while maintaining the human touch that defines great leadership.",
    category: "podcast",
    thumbnail: "https://images.unsplash.com/photo-1709846485906-30b28e7ed651?w=600",
    duration: "1:03:35",
    date: "2025-11-12",
    embedUrl: "https://youtu.be/t2dRS6L_hMs?si=10wlbmPVX0l8E_OU",
    guestName: "Dr. Sarah Chen",
    guestTitle: "AI Ethics Researcher, MIT",
    guestBio: "Dr. Sarah Chen is a leading researcher in AI ethics and has advised Fortune 500 companies on responsible AI implementation.",
    transcript: "Welcome to today's episode where we explore the intersection of leadership and artificial intelligence...",
    platforms: [
      { name: "Spotify", url: "https://spotify.com", icon: "spotify" },
      { name: "Apple Podcasts", url: "https://podcasts.apple.com", icon: "apple" },
      { name: "YouTube", url: "https://youtube.com", icon: "youtube" },
      { name: "Google Podcasts", url: "https://podcasts.google.com", icon: "google" },
    ],
    clips: [
      { title: "Key insight on AI adoption", timestamp: "12:34", duration: "2:15" },
      { title: "Leadership skills that AI can't replace", timestamp: "24:18", duration: "3:42" },
      { title: "Practical tips for leaders", timestamp: "38:05", duration: "4:20" },
    ],
  },
  {
    id: 2,
    slug: "building-high-performance-teams",
    title: "Building High-Performance Teams",
    description: "Strategies for creating teams that consistently exceed expectations.",
    fullDescription: "Discover the proven frameworks and methodologies for building teams that don't just meet targets but consistently exceed them. From hiring the right talent to fostering a culture of excellence, this episode covers everything you need to know about high-performance team building.",
    category: "podcast",
    thumbnail: "https://images.unsplash.com/photo-1590650153855-d9e808231d41?w=600",
    duration: "38:21",
    date: "2024-01-08",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    guestName: "Marcus Johnson",
    guestTitle: "Former Google VP of Engineering",
    guestBio: "Marcus led engineering teams of 500+ people at Google and now consults with startups on scaling culture.",
    transcript: "Building high-performance teams starts with understanding what truly drives excellence...",
    platforms: [
      { name: "Spotify", url: "https://spotify.com", icon: "spotify" },
      { name: "Apple Podcasts", url: "https://podcasts.apple.com", icon: "apple" },
      { name: "YouTube", url: "https://youtube.com", icon: "youtube" },
    ],
    clips: [
      { title: "The 3 pillars of team excellence", timestamp: "08:22", duration: "3:15" },
      { title: "Hiring for culture fit vs skill", timestamp: "19:45", duration: "4:10" },
    ],
  },
  {
    id: 3,
    slug: "interview-fortune-magazine",
    title: "Interview with Fortune Magazine",
    description: "Discussing the changing landscape of corporate leadership.",
    fullDescription: "An exclusive interview with Fortune Magazine where we discuss the evolving expectations of corporate leaders, the importance of purpose-driven leadership, and predictions for the future of business leadership.",
    category: "interview",
    thumbnail: "https://images.unsplash.com/photo-1559523161-0fc0d8b38a7a?w=600",
    duration: "22:15",
    date: "2024-01-20",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    guestName: "Emma Williams",
    guestTitle: "Senior Editor, Fortune Magazine",
    guestBio: "Emma covers leadership and corporate strategy for Fortune Magazine.",
    transcript: "Thank you for joining us today. Let's start with your perspective on modern leadership...",
    platforms: [
      { name: "YouTube", url: "https://youtube.com", icon: "youtube" },
      { name: "Fortune.com", url: "https://fortune.com", icon: "globe" },
    ],
    clips: [
      { title: "On purpose-driven leadership", timestamp: "05:30", duration: "2:45" },
      { title: "Predictions for 2025", timestamp: "18:20", duration: "3:55" },
    ],
  },
  {
    id: 4,
    slug: "harvard-business-review-podcast",
    title: "Harvard Business Review Podcast",
    description: "In-depth conversation about transformational leadership.",
    fullDescription: "Join the HBR IdeaCast for a comprehensive discussion on transformational leadership, change management, and building resilient organizations in uncertain times.",
    category: "interview",
    thumbnail: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600",
    duration: "52:08",
    date: "2024-01-12",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    guestName: "HBR IdeaCast Team",
    guestTitle: "Harvard Business Review",
    guestBio: "The HBR IdeaCast features the leading thinkers in business and management.",
    transcript: "Welcome to HBR IdeaCast. Today we're exploring transformational leadership...",
    platforms: [
      { name: "HBR.org", url: "https://hbr.org", icon: "globe" },
      { name: "Spotify", url: "https://spotify.com", icon: "spotify" },
      { name: "Apple Podcasts", url: "https://podcasts.apple.com", icon: "apple" },
    ],
    clips: [],
  },
  {
    id: 5,
    slug: "emotional-intelligence-quick-tips",
    title: "5 Minutes on Emotional Intelligence",
    description: "Quick insights on developing EQ as a leader.",
    fullDescription: "A quick, actionable guide to improving your emotional intelligence as a leader. Learn the key components of EQ and how to develop them in your daily practice.",
    category: "clip",
    thumbnail: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600",
    duration: "5:42",
    date: "2024-01-18",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    guestName: null,
    guestTitle: null,
    guestBio: null,
    transcript: "Emotional intelligence is the foundation of effective leadership...",
    platforms: [
      { name: "YouTube", url: "https://youtube.com", icon: "youtube" },
      { name: "Instagram", url: "https://instagram.com", icon: "instagram" },
    ],
    clips: [],
  },
  {
    id: 6,
    slug: "power-of-vulnerability",
    title: "The Power of Vulnerability",
    description: "Why showing vulnerability makes you a stronger leader.",
    fullDescription: "Explore why the most effective leaders embrace vulnerability rather than hide from it. This clip breaks down the science and practice of leading with authenticity.",
    category: "clip",
    thumbnail: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600",
    duration: "4:15",
    date: "2024-01-22",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    guestName: null,
    guestTitle: null,
    guestBio: null,
    transcript: "Many leaders believe they need to appear invulnerable...",
    platforms: [
      { name: "YouTube", url: "https://youtube.com", icon: "youtube" },
      { name: "LinkedIn", url: "https://linkedin.com", icon: "linkedin" },
    ],
    clips: [],
  },
  {
    id: 7,
    slug: "mastering-difficult-conversations",
    title: "Mastering Difficult Conversations",
    description: "A framework for navigating tough discussions with grace.",
    fullDescription: "Learn the CLEAR framework for handling difficult conversations in the workplace. From performance reviews to conflict resolution, this episode provides practical tools for any challenging discussion.",
    category: "podcast",
    thumbnail: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600",
    duration: "41:17",
    date: "2024-02-01",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    guestName: "Dr. Amanda Foster",
    guestTitle: "Organizational Psychologist",
    guestBio: "Dr. Foster specializes in workplace communication and conflict resolution.",
    transcript: "Difficult conversations are an unavoidable part of leadership...",
    platforms: [
      { name: "Spotify", url: "https://spotify.com", icon: "spotify" },
      { name: "Apple Podcasts", url: "https://podcasts.apple.com", icon: "apple" },
      { name: "YouTube", url: "https://youtube.com", icon: "youtube" },
    ],
    clips: [
      { title: "The CLEAR framework explained", timestamp: "10:15", duration: "5:30" },
      { title: "Role-play demonstration", timestamp: "28:40", duration: "8:15" },
    ],
  },
  {
    id: 8,
    slug: "bloomberg-leadership-interview",
    title: "Bloomberg Leadership Interview",
    description: "Discussing market trends and leadership in volatile times.",
    fullDescription: "A candid conversation with Bloomberg about leading through market uncertainty, making tough decisions, and maintaining team morale during challenging economic times.",
    category: "interview",
    thumbnail: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=600",
    duration: "28:33",
    date: "2024-02-05",
    embedUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
    guestName: "Bloomberg TV",
    guestTitle: "Bloomberg Markets",
    guestBio: "Bloomberg Markets covers global financial news and analysis.",
    transcript: "Thank you for joining Bloomberg Markets today...",
    platforms: [
      { name: "Bloomberg.com", url: "https://bloomberg.com", icon: "globe" },
      { name: "YouTube", url: "https://youtube.com", icon: "youtube" },
    ],
    clips: [
      { title: "On leading through uncertainty", timestamp: "08:45", duration: "3:20" },
    ],
  },
];

export const topicsData = [
  {
    id: "leadership",
    name: "Leadership",
    description: "Strategies for leading teams and organizations effectively",
    color: "#F97316",
    icon: "Crown",
  },
  {
    id: "growth",
    name: "Personal Growth",
    description: "Developing yourself to become your best version",
    color: "#0F172A",
    icon: "TrendingUp",
  },
  {
    id: "productivity",
    name: "Productivity",
    description: "Maximizing output while maintaining balance",
    color: "#059669",
    icon: "Zap",
  },
  {
    id: "communication",
    name: "Communication",
    description: "Mastering the art of effective communication",
    color: "#7C3AED",
    icon: "MessageSquare",
  },
  {
    id: "strategy",
    name: "Strategy",
    description: "Building and executing winning strategies",
    color: "#DC2626",
    icon: "Target",
  },
  {
    id: "mindset",
    name: "Mindset",
    description: "Developing the mental frameworks for success",
    color: "#2563EB",
    icon: "Brain",
  },
];

export const blogPosts = [
  {
    id: 1,
    slug: "five-habits-exceptional-leaders",
    title: "5 Habits of Exceptional Leaders",
    excerpt: "Discover the daily practices that set extraordinary leaders apart from the rest.",
    content: `Leadership is not about titles or positions—it's about habits, actions, and the impact you have on others. After studying hundreds of successful leaders across industries, I've identified five habits that consistently appear among the most exceptional ones.

## 1. They Start With Why

Exceptional leaders don't just communicate what needs to be done; they explain why it matters. This simple shift transforms compliance into commitment. When your team understands the purpose behind their work, they bring their full creativity and energy to the table.

## 2. They Listen More Than They Speak

The best leaders I've worked with are masterful listeners. They create space for others to share ideas, concerns, and feedback. This isn't passive listening—it's active engagement that makes people feel heard and valued.

## 3. They Embrace Discomfort

Growth happens outside our comfort zone, and exceptional leaders know this intimately. They seek out challenging situations, difficult conversations, and new experiences. More importantly, they model this behavior for their teams.

## 4. They Invest in Others

Great leaders see developing others as a core responsibility, not a nice-to-have. They mentor, coach, and create opportunities for their team members to grow. This investment pays dividends in loyalty, performance, and organizational capability.

## 5. They Practice Radical Self-Care

This might surprise you, but the best leaders prioritize their physical and mental well-being. They understand that they can't pour from an empty cup. Exercise, sleep, reflection, and personal relationships are non-negotiables.

---

The beautiful thing about habits is that anyone can develop them. Start with one, master it, and move to the next. Your leadership journey is a marathon, not a sprint.`,
    author: "Gaurav",
    date: "2024-01-20",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800",
    tags: ["Leadership", "Personal Growth", "Productivity"],
    topic: "leadership",
  },
  {
    id: 2,
    slug: "power-of-strategic-pauses",
    title: "The Power of Strategic Pauses",
    excerpt: "Why slowing down might be the fastest path to your goals.",
    content: `In our hyperconnected, always-on world, the idea of pausing seems almost radical. Yet, I've found that strategic pauses are one of the most powerful tools in a leader's arsenal.

## What Is a Strategic Pause?

A strategic pause is an intentional break from action to gain perspective, reflect, and recalibrate. It's not procrastination or avoidance—it's a deliberate choice to step back before moving forward more effectively.

## Why Pauses Work

Our brains need processing time. When we're constantly in action mode, we miss important signals, make hasty decisions, and burn out. Pauses allow our subconscious mind to work on problems, often leading to breakthrough insights.

## How to Implement Strategic Pauses

- **Daily Reflection**: Spend 10 minutes at the end of each day reviewing what worked and what didn't
- **Weekly Planning**: Block time to think strategically about the week ahead
- **Quarterly Retreats**: Step away from daily operations to assess progress and adjust course
- **Before Big Decisions**: Take 24 hours before making significant choices

The next time you feel the urge to push harder, consider whether a strategic pause might serve you better.`,
    author: "Gaurav",
    date: "2024-01-15",
    readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
    tags: ["Mindset", "Productivity", "Strategy"],
    topic: "mindset",
  },
  {
    id: 3,
    slug: "building-trust-remote-teams",
    title: "Building Trust in Remote Teams",
    excerpt: "Essential strategies for creating strong connections in distributed workplaces.",
    content: `The shift to remote and hybrid work has fundamentally changed how teams build trust. Without the natural interactions of an office environment, leaders must be intentional about creating connection and psychological safety.

## The Trust Challenge

In remote settings, we lose many of the informal moments that traditionally build trust—coffee chats, lunch conversations, hallway encounters. These micro-interactions might seem trivial, but they're actually the foundation of workplace relationships.

## Strategies That Work

### 1. Over-Communicate Intentionally
When in doubt, share more. Regular updates, clear expectations, and transparent decision-making build confidence in leadership.

### 2. Create Virtual Water Coolers
Dedicate time for non-work conversations. Virtual coffee chats, team social hours, or interest-based channels can recreate some of the spontaneity we've lost.

### 3. Show Vulnerability First
As a leader, modeling vulnerability gives permission for others to do the same. Share your challenges, admit mistakes, and ask for help.

### 4. Follow Through Consistently
Trust is built through reliable action over time. Do what you say you'll do, and acknowledge when you can't.

Remote work isn't going away. Leaders who master virtual trust-building will have a significant advantage.`,
    author: "Gaurav",
    date: "2024-01-10",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800",
    tags: ["Leadership", "Communication", "Strategy"],
    topic: "communication",
  },
  {
    id: 4,
    slug: "art-of-difficult-conversations",
    title: "The Art of Difficult Conversations",
    excerpt: "A practical framework for navigating challenging discussions with confidence.",
    content: `Every leader faces difficult conversations—performance issues, conflicts, delivering bad news. How you handle these moments defines your leadership more than any success.

## Why We Avoid Hard Conversations

Our brains are wired to avoid conflict. The discomfort of confrontation triggers our fight-or-flight response, leading many leaders to delay or avoid necessary discussions altogether.

## The CLEAR Framework

I developed this framework to help leaders approach difficult conversations with confidence:

**C - Center Yourself**
Before the conversation, take time to manage your emotions. Enter the discussion calm and grounded.

**L - Listen First**
Start by understanding the other person's perspective. Ask questions before making statements.

**E - Express With Clarity**
Be direct about the issue while maintaining respect. Avoid softening language that obscures your message.

**A - Agree on Actions**
End with clear next steps. What will change? Who's responsible? When will you follow up?

**R - Reflect and Follow Up**
After the conversation, reflect on what went well and what you'd do differently. Then, follow up as promised.

Difficult conversations become easier with practice. Each one is an opportunity to strengthen relationships and drive positive change.`,
    author: "Gaurav",
    date: "2024-01-05",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800",
    tags: ["Communication", "Leadership", "Personal Growth"],
    topic: "communication",
  },
  {
    id: 5,
    slug: "strategic-thinking-daily-practice",
    title: "Strategic Thinking as a Daily Practice",
    excerpt: "How to develop and maintain a strategic mindset in everyday leadership.",
    content: `Strategic thinking isn't reserved for annual planning sessions or executive retreats. The best strategists I know practice strategic thinking daily, making it an integrated part of how they approach every decision.

## Daily Strategic Habits

### Morning Vision Check
Spend 5 minutes each morning connecting your daily tasks to larger goals. Ask: "How does today's work move us toward our vision?"

### Question Assumptions
At least once a day, challenge an assumption you're operating under. What if the opposite were true?

### Think in Systems
Instead of reacting to individual events, look for patterns and connections. How do different parts of your organization or market interact?

### Practice Scenario Planning
When making decisions, quickly run through multiple scenarios. What happens if this succeeds? Fails? What's plan B?

Strategic thinking is a muscle. The more you exercise it, the stronger it becomes.`,
    author: "Gaurav",
    date: "2024-01-01",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800",
    tags: ["Strategy", "Leadership", "Productivity"],
    topic: "strategy",
  },
];

export const servicesData = {
  speaking: {
    title: "Speaking",
    tagline: "Inspire Your Audience",
    description: "Engaging keynotes and presentations that transform perspectives and drive action.",
    image: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=800",
    topics: [
      "Leadership in the Digital Age",
      "Building High-Performance Cultures",
      "The Future of Work",
      "Resilience and Adaptability",
      "Custom Topics Available",
    ],
    testimonial: {
      quote: "One of the most impactful speakers we've ever had. The insights shared transformed how our leadership team approaches challenges.",
      author: "Sarah Chen",
      title: "CEO, TechCorp Global",
    },
    cta: "Book a Speaking Engagement",
  },
  consulting: {
    title: "Consulting",
    tagline: "Transform Your Organization",
    description: "Strategic consulting to help organizations overcome challenges and achieve breakthrough results.",
    image: "https://images.unsplash.com/photo-1573166364839-1bfe9196c23e?w=800",
    services: [
      "Organizational Transformation",
      "Leadership Development Programs",
      "Culture Change Initiatives",
      "Strategic Planning Facilitation",
      "Performance Optimization",
    ],
    testimonial: {
      quote: "The consulting engagement exceeded our expectations. We saw measurable improvements in team performance within the first quarter.",
      author: "Michael Rodriguez",
      title: "COO, Fortune 500 Company",
    },
    cta: "Start a Consulting Project",
  },
  advisory: {
    title: "Advisory",
    tagline: "Strategic Partnership",
    description: "Ongoing advisory relationships for CEOs and executive teams seeking a trusted thought partner.",
    image: "https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=800",
    offerings: [
      "Monthly Strategic Sessions",
      "On-Call Advisory Support",
      "Board Preparation",
      "Executive Coaching",
      "Crisis Navigation",
    ],
    testimonial: {
      quote: "Having a strategic advisor has been invaluable. The objective perspective and expert guidance have helped us navigate complex decisions with confidence.",
      author: "Jennifer Park",
      title: "Founder & CEO, ScaleUp Ventures",
    },
    cta: "Explore Advisory Services",
  },
};

export const contactServiceOptions = [
  { value: "speaking", label: "Speaking Engagement" },
  { value: "consulting", label: "Consulting Project" },
  { value: "advisory", label: "Advisory Services" },
  { value: "podcast", label: "Podcast Appearance" },
  { value: "media", label: "Media Inquiry" },
  { value: "other", label: "Other" },
];

export const booksData = [
  {
    id: 1,
    slug: "the-leadership-mindset",
    title: "The Leadership Mindset",
    subtitle: "Transform Your Thinking, Transform Your Results",
    description: "A comprehensive guide to developing the mental frameworks that drive exceptional leadership. Learn how to shift your perspective, overcome limiting beliefs, and lead with confidence in any situation.",
    fullDescription: `In today's rapidly changing business landscape, the difference between good leaders and great leaders often comes down to mindset. "The Leadership Mindset" is your comprehensive guide to developing the mental frameworks that drive exceptional leadership.

Drawing from two decades of research and hands-on experience with Fortune 500 executives, this book reveals the thought patterns, beliefs, and mental models that separate transformational leaders from the rest.

You'll discover:
• How to identify and overcome the limiting beliefs holding you back
• The five mental shifts that accelerate leadership growth
• Practical exercises to build unshakeable confidence
• Strategies for making better decisions under pressure
• How to lead authentically while driving results

Whether you're a first-time manager or a seasoned executive, this book provides the tools you need to elevate your leadership to the next level.`,
    coverImage: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400",
    publishDate: "2023",
    publisher: "HarperCollins Leadership",
    pages: 288,
    isbn: "978-0-123456-78-9",
    amazonUrl: "https://amazon.com",
    barnesNobleUrl: "https://barnesandnoble.com",
    audibleUrl: "https://audible.com",
    kindleUrl: "https://amazon.com/kindle",
    featured: true,
    testimonials: [
      {
        quote: "A must-read for any aspiring leader. Practical, insightful, and transformative.",
        author: "Simon Sinek",
        title: "Author of Start With Why",
      },
      {
        quote: "This book changed how I approach leadership challenges.",
        author: "Brené Brown",
        title: "Research Professor, University of Houston",
      },
      {
        quote: "Finally, a leadership book that goes beyond theory and provides real, actionable insights.",
        author: "Adam Grant",
        title: "Organizational Psychologist, Wharton",
      },
    ],
    chapters: [
      "The Foundation of Leadership Thinking",
      "Breaking Free from Limiting Beliefs",
      "Building Confidence Through Action",
      "The Art of Strategic Decision Making",
      "Leading Through Uncertainty",
      "Developing Emotional Intelligence",
      "Creating a Growth Mindset Culture",
      "The Leader's Daily Practice",
    ],
    keyTakeaways: [
      "Mindset is the foundation of all leadership effectiveness",
      "Limiting beliefs can be identified and systematically overcome",
      "Confidence is built through action, not affirmation",
      "Great decisions come from great mental frameworks",
    ],
  },
  {
    id: 2,
    slug: "high-performance-teams",
    title: "High-Performance Teams",
    subtitle: "Building Groups That Exceed Expectations",
    description: "Discover the secrets behind the world's most effective teams. This book provides actionable frameworks for hiring, developing, and leading teams that consistently deliver exceptional results.",
    fullDescription: `Why do some teams consistently outperform while others struggle to meet basic expectations? After studying hundreds of high-performing teams across industries, I've identified the patterns, practices, and principles that separate exceptional teams from average ones.

"High-Performance Teams" provides a complete blueprint for building and leading teams that don't just meet targets—they shatter them.

Inside you'll learn:
• The science of team composition and why diversity matters
• How to hire for both skill and culture fit
• The rituals and routines of top-performing teams
• Managing conflict to drive innovation
• Scaling team excellence as your organization grows

Packed with case studies, practical exercises, and proven frameworks, this book gives you everything you need to transform any group into a high-performance team.`,
    coverImage: "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=400",
    publishDate: "2021",
    publisher: "Penguin Business",
    pages: 256,
    isbn: "978-0-987654-32-1",
    amazonUrl: "https://amazon.com",
    barnesNobleUrl: "https://barnesandnoble.com",
    audibleUrl: "https://audible.com",
    kindleUrl: "https://amazon.com/kindle",
    featured: false,
    testimonials: [
      {
        quote: "The definitive guide to team building in the modern workplace.",
        author: "Patrick Lencioni",
        title: "Author of The Five Dysfunctions of a Team",
      },
      {
        quote: "Practical wisdom for anyone who leads a team.",
        author: "Kim Scott",
        title: "Author of Radical Candor",
      },
    ],
    chapters: [
      "What Makes Teams Excel",
      "The Hiring Blueprint",
      "Culture by Design",
      "Managing Performance",
      "Scaling Excellence",
      "Remote and Hybrid Teams",
      "Navigating Team Conflict",
    ],
    keyTakeaways: [
      "Team composition matters more than individual talent",
      "Culture is built through consistent daily actions",
      "High performance requires psychological safety",
      "The best teams embrace productive conflict",
    ],
  },
];

export const marketplaceData = [
  {
    id: 1,
    name: "Leadership Masterclass",
    description: "A comprehensive 8-week online course covering all aspects of modern leadership.",
    price: 497,
    originalPrice: 697,
    image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400",
    category: "course",
    featured: true,
    features: [
      "40+ video lessons",
      "Downloadable workbooks",
      "Private community access",
      "Monthly live Q&A calls",
      "Certificate of completion",
    ],
  },
  {
    id: 2,
    name: "The Leader's Toolkit",
    description: "Essential templates, frameworks, and resources for effective leadership.",
    price: 97,
    originalPrice: null,
    image: "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400",
    category: "digital",
    featured: false,
    features: [
      "50+ templates",
      "Strategy frameworks",
      "Meeting agendas",
      "Performance review guides",
      "Lifetime updates",
    ],
  },
  {
    id: 3,
    name: "1-on-1 Coaching Session",
    description: "A focused 90-minute coaching session to address your specific leadership challenges.",
    price: 500,
    originalPrice: null,
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400",
    category: "coaching",
    featured: true,
    features: [
      "90-minute video call",
      "Pre-session questionnaire",
      "Personalized action plan",
      "30-day email support",
      "Recording provided",
    ],
  },
  {
    id: 4,
    name: "Team Assessment Workshop",
    description: "A comprehensive assessment and workshop for your leadership team.",
    price: 2500,
    originalPrice: null,
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=400",
    category: "workshop",
    featured: false,
    features: [
      "Team assessments",
      "Half-day workshop",
      "Detailed report",
      "Action recommendations",
      "Follow-up session",
    ],
  },
];
